import { FaMapMarkerAlt, FaBed, FaMoon } from "react-icons/fa";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { useContext } from "react";
import MyContext from "../../context/Context";

const FeaturedResorts = () => {
 const resorts = [
   {
     id: 1,
     name: "Stardom Resort Jaipur",
     location: "Jaipur",
     guests: 50,
     nights: 2,
     price: "750,000",
     image: "https://images.unsplash.com/photo-1566073771259-6a8506099945",
     gallery: [
       "https://images.unsplash.com/photo-1505691723518-36a5ac3be353",
       "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
       "https://images.unsplash.com/photo-1519741497674-611481863552",
       "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1",
     ],
     description:
       "Stardom Resort is located near the airport and offers a luxurious stay with beautiful wedding venues and royal architecture.",
     facilities: ["AC", "Swimming Pool", "WiFi", "TV", "Water Bottles"],
     menu: ["Alcohol Menu Available", "Multi Cuisine Buffet"],
     roomRates: [
       "Double Occupancy (2 guests) Per Room Per Night - 13000",
       "Triple Occupancy (3 guests) Per Room Per Night - 17000",
     ],
     inclusions: ["Breakfast", "Lunch", "Dinner", "Taxes", "Airport Transfer"],
     weddingBudget: "5 Lakhs including Decor & Artists",

     // ✅ NEW FIELD
     packages: [
       {
         title: "Silver Wedding Package",
         description: "Basic decor setup with floral stage and DJ night.",
         price: "2,50,000",
       },
       {
         title: "Gold Wedding Package",
         description: "Premium decor, live music band, bridal entry theme.",
         price: "4,00,000",
       },
       {
         title: "Royal Wedding Package",
         description: "Luxury decor, celebrity artist, full event management.",
         price: "7,50,000",
       },
     ],
   },

   {
     id: 2,
     name: "Beleza By The Beach",
     location: "Goa",
     guests: 50,
     nights: 2,
     price: "1,180,000",
     image:
       "https://awayddings.s3.ap-south-1.amazonaws.com/images/1719652904Ariel%20Pic%20.jpg",
     gallery: [
       "https://images.unsplash.com/photo-1505691723518-36a5ac3be353",
       "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
       "https://images.unsplash.com/photo-1519741497674-611481863552",
       "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1",
     ],
     description:
       "Beleza By The Beach offers stunning beachfront wedding venues with sunset views and premium hospitality.",
     facilities: ["Beach Access", "Swimming Pool", "WiFi", "Spa", "Bar"],
     menu: ["Alcohol Menu Available", "Seafood Special Menu"],
     roomRates: [
       "Double Occupancy (2 guests) Per Room Per Night - 15000",
       "Triple Occupancy (3 guests) Per Room Per Night - 19000",
     ],
     inclusions: ["Breakfast", "Lunch", "Dinner", "Beach Decor", "Taxes"],
     weddingBudget: "8 Lakhs including Beach Decor & Artists",
     packages: [
       {
         title: "Beach Bliss Package",
         description:
           "Simple beach mandap setup with floral decor and DJ night.",
         price: "3,50,000",
       },
       {
         title: "Sunset Celebration Package",
         description:
           "Premium beach decor, live music, bridal entry and fireworks.",
         price: "6,00,000",
       },
       {
         title: "Luxury Coastal Wedding",
         description:
           "Full beach wedding planning with celebrity artist & luxury decor.",
         price: "9,50,000",
       },
     ],
   },

   {
     id: 3,
     name: "Achrol Niwas, Jaipur",
     location: "Jaipur",
     guests: 50,
     nights: 2,
     price: "800,000",
     image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
     gallery: [
       "https://images.unsplash.com/photo-1505691723518-36a5ac3be353",
       "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
       "https://images.unsplash.com/photo-1519741497674-611481863552",
       "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1",
     ],
     description:
       "Achrol Niwas is a heritage-style hotel offering palace-like wedding experiences in Jaipur.",
     facilities: ["AC", "Heritage Rooms", "WiFi", "Garden Area", "Parking"],
     menu: ["Alcohol Menu Available", "Rajasthani Special Menu"],
     roomRates: [
       "Double Occupancy (2 guests) Per Room Per Night - 14000",
       "Triple Occupancy (3 guests) Per Room Per Night - 18000",
     ],
     inclusions: ["Breakfast", "Lunch", "Dinner", "Taxes", "Airport Transfer"],
     weddingBudget: "6 Lakhs including Traditional Decor",
     packages: [
       {
         title: "Traditional Royal Package",
         description:
           "Rajasthani folk welcome, basic palace decor and DJ night.",
         price: "3,00,000",
       },
       {
         title: "Heritage Grand Package",
         description:
           "Premium palace decor, live folk artists and royal entry.",
         price: "5,50,000",
       },
       {
         title: "Maharaja Wedding Package",
         description:
           "Elephant entry, luxury decor and full wedding management.",
         price: "8,00,000",
       },
     ],
   },

   {
     id: 4,
     name: "Royal Palace Udaipur",
     location: "Udaipur",
     guests: 100,
     nights: 3,
     price: "1,500,000",
     image: "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1",
     gallery: [
       "https://images.unsplash.com/photo-1505691723518-36a5ac3be353",
       "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
       "https://images.unsplash.com/photo-1519741497674-611481863552",
       "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1",
     ],
     description:
       "Royal Palace Udaipur provides lake-facing luxury wedding venues with royal ambiance and premium decor.",
     facilities: ["Lake View", "Swimming Pool", "WiFi", "Banquet Hall", "Spa"],
     menu: ["Alcohol Menu Available", "Royal Thali", "International Cuisine"],
     roomRates: [
       "Double Occupancy (2 guests) Per Room Per Night - 20000",
       "Triple Occupancy (3 guests) Per Room Per Night - 25000",
     ],
     inclusions: [
       "Breakfast",
       "Lunch",
       "Dinner",
       "Royal Decor",
       "Airport Transfer",
     ],
     weddingBudget: "12 Lakhs including Premium Decor & Artists",
     packages: [
       {
         title: "Lake View Wedding",
         description: "Beautiful lake-facing mandap with floral decor and DJ.",
         price: "6,50,000",
       },
       {
         title: "Royal Lake Palace Package",
         description: "Luxury decor, live band and royal themed entry.",
         price: "10,00,000",
       },
       {
         title: "Ultimate Royal Celebration",
         description:
           "Celebrity performance, premium decor and fireworks show.",
         price: "15,00,000",
       },
     ],
   },

   {
     id: 5,
     name: "Goa Luxury",
     location: "Goa",
     guests: 80,
     nights: 2,
     price: "950,000",
     image: "https://images.unsplash.com/photo-1505691723518-36a5ac3be353",
     gallery: [
       "https://images.unsplash.com/photo-1505691723518-36a5ac3be353",
       "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
       "https://images.unsplash.com/photo-1519741497674-611481863552",
       "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1",
     ],
     description:
       "Goa Luxury Retreat offers tropical wedding vibes with beachfront ceremonies and lively celebrations.",
     facilities: ["Beach Access", "Swimming Pool", "WiFi", "DJ Setup", "Bar"],
     menu: ["Alcohol Menu Available", "Continental Buffet"],
     roomRates: [
       "Double Occupancy (2 guests) Per Room Per Night - 16000",
       "Triple Occupancy (3 guests) Per Room Per Night - 21000",
     ],
     inclusions: ["Breakfast", "Lunch", "Dinner", "Taxes", "Decor Setup"],
     weddingBudget: "7 Lakhs including Beach Decor",

     packages: [
       {
         title: "Tropical Wedding Package",
         description: "Basic beach decor with DJ and buffet setup.",
         price: "4,00,000",
       },
       {
         title: "Premium Beach Party",
         description: "Luxury decor, cocktail night and live band.",
         price: "6,50,000",
       },
       {
         title: "Goa Grand Wedding",
         description: "Full beach wedding management with celebrity artist.",
         price: "10,00,000",
       },
     ],
   },

   {
     id: 6,
     name: "Heritage Haveli",
     location: "Jaipur",
     guests: 60,
     nights: 2,
     price: "680,000",
     image:
       "https://images.unsplash.com/photo-1729605412184-8d796f9c6f66?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDk1NzN8MHwxfHNlYXJjaHwxOHx8cmVzb3J0c3xlbnwwfHx8fDE3NzEwNzU0MzV8MA&ixlib=rb-4.1.0&q=80&w=400",
     gallery: [
       "https://images.unsplash.com/photo-1505691723518-36a5ac3be353",
       "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
       "https://images.unsplash.com/photo-1571896349842-33c89424de2d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDk1NzN8MHwxfHNlYXJjaHw2fHxyZXNvcnRzfGVufDB8fHx8MTc3MTA3NTQzNXww&ixlib=rb-4.1.0&q=80&w=400",
       "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1",
     ],
     description:
       "Heritage Haveli is a boutique property ideal for intimate royal weddings with traditional Rajasthani touch.",
     facilities: ["AC", "WiFi", "Courtyard Venue", "Parking", "Room Service"],
     menu: ["Alcohol Menu Available", "Rajasthani Cuisine"],
     roomRates: [
       "Double Occupancy (2 guests) Per Room Per Night - 12000",
       "Triple Occupancy (3 guests) Per Room Per Night - 16000",
     ],
     inclusions: ["Breakfast", "Lunch", "Dinner", "Taxes"],
     weddingBudget: "4 Lakhs including Basic Decor",
     packages: [
       {
         title: "Intimate Royal Package",
         description:
           "Royal Palace Udaipur offers an unforgettable destination wedding experience set against the breathtaking backdrop of serene lakes and majestic Aravalli hills. This luxury palace venue blends timeless royal architecture with modern elegance, creating the perfect setting for grand celebrations and intimate ceremonies alike. From stunning lake-facing mandaps to beautifully decorated banquet halls, every corner of the property radiates charm and sophistication.",
         price: "2,50,000",
       },
       {
         title: "Haveli Grand Celebration",
         description:
           "The palace features spacious heritage rooms and premium suites designed with intricate detailing, ensuring comfort and indulgence for your guests. The expansive lawns and terrace venues provide spectacular sunset views, ideal for mehendi functions, cocktail evenings, and reception nights under the stars. Expert event planners and in-house decor teams work closely with you to curate customized themes, floral arrangements, and lighting concepts that reflect your personal style.",
         price: "4,50,000",
       },
       {
         title: "Royal Heritage Wedding",
         description:
           "Guests can indulge in curated multi-cuisine menus crafted by experienced chefs, offering everything from traditional Rajasthani delicacies to international gourmet selections. With impeccable hospitality, seamless event management, and regal ambiance, Royal Palace Udaipur transforms your wedding into a truly magical and royal celebration that will be cherished for a lifetime.",
         price: "7,00,000",
       },
     ],
   },
 ];
  const context = useContext(MyContext);
  const { loading, setLoading, getAllResort, getAllResortFunction } = context;

  return (
    <section className="bg-gray-50 py-12 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-serif text-gray-800">
            Featured <span className="text-[#b76d68]">Wedding Stays</span>
          </h2>
          <p className="text-gray-500 mt-4 font-outfit">
            Handpicked venues for your dream wedding
          </p>
          {/* Decorative Divider */}
          <div className="flex justify-center items-center gap-3 mt-6">
            <div className="w-10 h-[1px] bg-red-300"></div>
            <div className="w-2 h-2 bg-red-400 rounded-full"></div>
            <div className="w-10 h-[1px] bg-red-300"></div>
          </div>
        </div>

        {/* 🔥 Custom Arrows */}
        <div className="custom-prev absolute -left-6 top-[55%] -translate-y-1/2 z-20 cursor-pointer bg-white shadow-lg p-3 rounded-full hover:bg-red-500 hover:text-white transition hidden md:flex">
          <FiChevronLeft size={24} />
        </div>

        <div className="custom-next absolute -right-6 top-[55%] -translate-y-1/2 z-20 cursor-pointer bg-white shadow-lg p-3 rounded-full hover:bg-red-500 hover:text-white transition hidden md:flex">
          <FiChevronRight size={24} />
        </div>

        {/* Swiper */}
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation={{
            nextEl: ".custom-next",
            prevEl: ".custom-prev",
          }}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {resorts.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white mb-12 rounded-2xl shadow-md hover:shadow-xl transition duration-300 overflow-hidden group">
                {/* Image */}
                <div className="overflow-hidden">
                  <Link to={`/resort/${index}`} state={{ resort: item }}>
                    <img
                      src={`${item.image}?auto=format&fit=crop&w=800&q=80`}
                      alt={item.name}
                      className="w-full h-[250px] object-cover group-hover:scale-105 transition duration-500"
                    />
                  </Link>
                </div>

                {/* Content */}
                <div className="p-4">
                  <h3 className="text-lg font-semibold font-serif text-gray-800 mb-4">
                    {item.name}
                  </h3>

                  <div className="flex flex-wrap font-serif items-center gap-4 text-sm text-gray-500 mb-4">
                    <div className="flex items-center gap-2">
                      <FaMapMarkerAlt className="text-gray-400" />
                      {item.location}
                    </div>

                    <div className="flex items-center gap-2">
                      <FaBed className="text-gray-400" />
                      Guests: {item.guests}
                    </div>

                    <div className="flex items-center gap-2">
                      <FaMoon className="text-gray-400" />
                      Nights: {item.nights}
                    </div>
                  </div>

                  <div className="text-lg font-semibold text-gray-800">
                    ₹ {item.price}
                    <span className="text-sm text-gray-400 font-normal">
                      {" "}
                      (tax incl.)
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default FeaturedResorts;
